import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ProviderBase from "components/layout/ProviderBase";
import ProviderPayoutReportTable from "../widgets/ProviderPayoutReportTable";
import * as ProviderApi from "api/ProviderApi";
import { getProviders } from "api/ProviderApi";
import getProviderId from "utils/getProviderId";
import { getNodeId } from "utils/AdminData";
import filter from "lodash/filter";
import flatMap from "lodash/flatMap";
import includes from "lodash/includes";
import map from "lodash/map";
import {
  PermissionTypes,
  userHasPermission,
} from "utils/permissions/rolesPermissions";
import * as UserPermissions from "constants/UserPermissions";
import Dropdown from "components/common/Dropdown";
import Button from "components/common/Button";
import TextBox from "components/common/TextBox";
import { NHO } from "constants/OrgNodeTypes";
import { handleErrorResponse } from "utils/request";

function ProviderPayoutReport(props) {
  const [checkSummary, setCheckSummary] = useState(null);
  const [dropDownValue, setDropDownValue] = useState(1);
  const [checkNumber, setCheckNumber] = useState(null);
  const [downloadParameters, setDownloadParameters] = useState({});
  const [manufacturers, setManufacturers] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
      setLoading(true);    
      getProviders()
      .then((res) => {
          const mans = filter(res.body, { visibleInCorporateDashboard: true });
          const ddOptions = map(mans, item => ({
              value: item.id,
              name: item.name
            }));
          setManufacturers(ddOptions);
          setDropDownValue(BOEHRINGER_INGLHEIM);
      })
      .catch((err) => {
          handleErrorResponse("loading Manufacturers", err);
      })
      .finally(() => {
          setLoading(false);
      })
    };
  
    useEffect(() => {
      if (!manufacturers?.length) {
        fetchData();
      }
      }, []);

  const checkNumberInputStyle = {
    marginTop: "0.5rem",
  };

  const loadPayoutReport =  (model) => {

    if(props.node?.nodeType === NHO) {
      ProviderApi.getNHOProviderCheckSummary(checkNumber)
      .then((res) => {
        let recs = map(res.body, (d) => ({ ...d, id: d.clinicId }));
        setCheckSummary(recs);
      })
      .catch((error) => {
        handleErrorResponse("loading payout report", error);
      })
    } else {
      ProviderApi.getProviderCheckSummary(model)
      .then((res) => {
        let recs = map(res.body, (d) => ({ ...d, id: d.clinicId }));
        setCheckSummary(recs);
      })
      .catch((error) => {
        handleErrorResponse("loading payout report", error);
      })
    };
  };

  const handleStatusFilterChanged = (option) => {
    setDropDownValue(option.value);
  };

  const handleCheckInput = (number) => {
    setCheckNumber(number.value);
  };

  const handleSubmit = () => {
    let search = ({
      manufacturerId: dropDownValue,
      checkNumber: checkNumber,
      corporateGroupProviderId: props.providerId,
    });
    loadPayoutReport(search);
  };

  useEffect(() => {
    if(props.node?.nodeType === NHO) {
      setDownloadParameters(checkNumber)
    } else {
      setDownloadParameters({
        "manufacturerId": dropDownValue,
        "checkNumber": checkNumber,
        "corporateGroupProviderId": props.providerId,
      })
    }
  }, [dropDownValue, checkNumber, props.providerId])

  return (
    <ProviderBase
      location={props.location}
      nodeId={props.nodeId}
      providerId={props.providerId}
      docTitle={"Payout Report"}
      pageTitle={"Reports"}
      collapsible
    >
      <div>
        <div className="flex flex-wrap">
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <Dropdown
              name="ddlProvider"
              wide
              placeHolder={"Choose a Manufacturer"}
              value={dropDownValue}
              onChange={handleStatusFilterChanged}
              options={manufacturers}
              disabled={props.node?.nodeType === NHO}
            />
          </div>
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <TextBox
              name="clinicAlias"
              placeholder="Enter Check Number..."
              style={checkNumberInputStyle}
              value={checkNumber}
              onChange={(data) => handleCheckInput(data)}
              input={true}
            />
          </div>
          <div className="flex-none flex flex-centered spaced-content margin-sm">
            <Button
              className="margin-right-x-sm"
              onClick={() => handleSubmit()}
              disabled={!checkNumber}
            >
              Search
            </Button>
          </div>
        </div>

          <ProviderPayoutReportTable
            isAdminReport={false}
            checkData={checkSummary}
            downloadParameters={downloadParameters}
            isNHO={props.node?.nodeType === NHO}
          ></ProviderPayoutReportTable>
        
      </div>
    </ProviderBase>
  );
}

export default connect(
  (state, ownProps) => {
    const params = ownProps?.match?.params || {};
    const userProfile = state.user.userProfile;
    const providerId = getProviderId(params, userProfile);
    const nodeId = getNodeId(state, ownProps);
    const node = state.entities.nodes?.[nodeId];
    const corporateGroupProviderIds = flatMap(filter(state.entities.providers, { isCorporateGroup: true }), "id");
    const isCorporateGroup = !!includes(corporateGroupProviderIds, node?.providerId);
    //Permissions
    const canViewCorporateGroupClinic = userHasPermission(PermissionTypes.VIEW, UserPermissions.CORPORATE_GROUP_CLINIC, userProfile);

    return {
      userProfile,
      providerId,
      nodeId,
      node,
      isCorporateGroup,
      isAdmin: !!(
        ownProps?.location?.pathname?.includes("/admin") &&
        providerId &&
        nodeId
      ),
      territoryId: params.territoryId,
      districtId: params.districtId,
      regionId: params.regionId,
      isLoggedIn: state.user.isLoggedIn,

      // Permissions
      canViewCorporateGroupClinic,
    };
  },
  (dispatch) => ({
    loadCurrentUser: () => dispatch(UserActions.loadCurrentUser()),
  })
)(ProviderPayoutReport);
